// extracted by mini-css-extract-plugin
export default {"loginContainer":"login_loginContainer__XPpQS","leftSection":"login_leftSection__5ac1-","rightSection":"login_rightSection__RJBD+"};